<template>
    <div class="gz-copyrights">
        <span>&copy;</span>
        <span>&nbsp;{{ dates }}&nbsp;</span>
        <span>{{ domen }}</span>
    </div>
</template>

<script>
export default {
    name: 'Copyrights',

    props: {
        dates: {
            type: String,
            default: '2020 - 2021'
        },
        domen: {
            type: String,
            default: ''
            // default: 'pechnik82.ru'
        }
    }
}
</script>